/** datetime-local is a Beijing wall clock; never interpret it in the device timezone. */
export function beijingInputToIso(value: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return null;
  const date = new Date(`${value}:00+08:00`);
  if (!Number.isFinite(date.getTime())) return null;
  if (beijingInputValue(date) !== value) return null;
  return date.toISOString();
}

export function beijingInputValue(date: Date): string {
  return new Date(date.getTime() + 8 * 60 * 60 * 1000).toISOString().slice(0, 16);
}
